import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kirkwoodMOConfig } from "./data";

export default function KirkwoodMOPage() {
  return <CityPageTemplate config={kirkwoodMOConfig} />;
}